import { render, staticRenderFns } from "./pageHeaderCommon.vue?vue&type=template&id=6fb59e5c&scoped=true&"
import script from "./pageHeaderCommon.vue?vue&type=script&lang=js&"
export * from "./pageHeaderCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb59e5c",
  null
  
)

export default component.exports